import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Col, Row } from 'react-bootstrap'
import _ from 'lodash'
import classNames from 'classnames'
import Checkbox from 'components/Checkbox/component'
import Info from 'components/Info/component'
import ReactSlider from 'react-slider'
import { connectorIcons } from 'components/LocationMap/libs/assets'
import { defaultMarkerFilter, connectorNames, powers } from '../libs/getDefaultOptions'
import translate from 'libs/translate'
import Modal from 'components/Modal'

import './style.scss'

const LocationFilter = ({ show, filter, onHide, onFilterApply, toggleFilterModal }) => {
    const [filterState, setFilterState] = useState({ ...filter })

    const updateFilter = (prop, value) => {
        setFilterState(state => ({ ...state, [prop]: value }))
    }

    const applyFilter = (filter) => {
        const f = filter || filterState
        setFilterState(state => ({ ...state, ...f }))
        onFilterApply(f)
    }

    const modalOnnHide = () => {
        setFilterState(state => ({ ...state, filter }))
        onHide()
    }

    return (
        <Modal
            style={{ opacity: 1 }}
            show={show}
            className='LocationFilterModal'
            onHide={modalOnnHide}>
            <div className='locationFilter_modal_wrapper'>
                <div className='modal_header'>
                    <div className='modal_title'>{translate('landing_filter_title')}</div>
                    <button className='close_button' onClick={() => toggleFilterModal(false)}>
                        <span className='close_icon'>x</span>
                    </button>
                </div>
                <div className='LocationFilter'>
                    <hr />
                    <div>{translate('landing_filter_title_availability')} <Info>{translate('landing_filter_info_availability')}</Info></div>
                    <Checkbox onClick={(v) => { updateFilter('showOnlyAvailable', v) }}
                        checked={filterState.showOnlyAvailable}>{translate('landing_filter_show_only_available')}</Checkbox>
                    <hr />
                    <div>{translate('landing_filter_title_power')} <small>(kW)</small></div>
                    <PowerSelector onChange={(p) => { updateFilter('minPower', p) }}
                        value={filterState.minPower}
                    />
                    <hr />
                    <div>{translate('landing_filter_title_connector_type')}</div>
                    <ConnectorTypeSelector onChange={(connectors) => { updateFilter('connectors', connectors) }}
                        value={filterState.connectors}
                    />
                    <hr />
                    <div>{translate('landing_filter_title_only_tnm_card')} <Info>{translate('landing_filter_info_only_tnm_card')}</Info></div>
                    <Checkbox onClick={(v) => { updateFilter('onlyAccessibleWithCard', v) }}
                        checked={filterState.onlyAccessibleWithCard}>{translate('landing_filter_only_tnm_card')}</Checkbox>
                    <hr />
                </div>
                <div className='modal_footer'>
                    <Button className='modal_button-left' variant='link' size='large' onClick={() => { applyFilter(defaultMarkerFilter) }}>{translate('landing_filter_button_reset_filter')}</Button>
                    <Button className='modal_button-right' variant='primary' size='large' onClick={() => { applyFilter() }}>{translate('landing_filter_button_apply_filter')}</Button>
                </div>
            </div>
        </Modal>
    )
}
LocationFilter.propTypes = {
    show: PropTypes.bool,
    filter: PropTypes.object,
    onHide: PropTypes.func,
    onFilterApply: PropTypes.func,
    toggleFilterModal: PropTypes.func
}

const ConnectorTypeSelector = ({ onChange: propOnChange, value: propValue }) => {
    const isChecked = (type) => propValue.find(val => type === val) ? true : false

    const getIconName = (connectorTypeId) => {
        return {
            'Domestic': 'domestic',
            'TepcoCHAdeMO': 'tepcochademo',
            'Type1': 'type1',
            'Type2': 'type2',
            'Type2Combo': 'type2combo',
            'Type3': 'type3'
        }[connectorTypeId] || 'unknown'
    }

    const onChange = (value) => {
        const set = new Set(propValue)
        const newSet = set.has(value) ?
            set.delete(value) && Array.from(set)
            : Array.from(set.add(value))

        propOnChange(newSet)
    }

    return (
        <div className='ConnectorTypeSelector'>
            <Row>
                {
                    _(connectorNames)
                        .map((name, id) => {
                            const calculatedName = typeof name === 'function' ? name() : name;

                            return [
                                calculatedName,
                                <Col md={6} sm={6} key={id}>
                                    <Connector
                                        checked={isChecked(id)}
                                        onClick={onChange}
                                        icon={getIconName(id)} value={id} name={calculatedName}
                                    />
                                </Col>
                            ]
                        })
                        .sortBy(i => i[0])
                        .map(i => i[1])
                        .value()
                }
            </Row>
        </div>
    )
}
ConnectorTypeSelector.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.array
}

const Connector = ({ checked, value, icon, name, onClick }) => {
    const c = classNames('Connector', { checked })

    return (
        <div className={c} >
            <Checkbox checked={checked} onClick={() => { onClick(value) }}>
                <img src={connectorIcons[icon].default} />{' '}
                {name}
            </Checkbox>
        </div>
    )

}
Connector.propTypes = {
    checked: PropTypes.bool,
    value: PropTypes.string,
    icon: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func
}

const PowerSelector = ({ value, onChange }) => {
    const getPower = (index) => powers[index] || 0
    const getIndexFromPower = (p) => powers.indexOf(p)

    return (
        <div className='PowerSelector'>
            <ReactSlider
                onChange={(index) => onChange(getPower(index))}
                value={getIndexFromPower(value)}
                max={powers.length - 1}
                className="horizontal-slider"
                thumbClassName="slider-thumb"
                trackClassName="slider-track"
            >
            </ReactSlider>
            <div className='PowerSelector__labels'>
                {powers.map((p) => {
                    const index = getIndexFromPower(p)
                    const cssClass = `PowerSelector__labels__label ${String.fromCharCode(97 + index)}`
                    return <div key={index} className={cssClass} onClick={() => onChange(p)}>{p}</div>
                })}
            </div>
        </div>
    )
}
PowerSelector.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
}

export default LocationFilter
